import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setToken, setRefreshToken, api } from "../lib/api.js";

/**
 * VorksReturnPage — landed here after Vorks ID round-trip. The backend
 * redirected the user to /vorks-return#access=...&refresh=... so we can
 * pull the tokens out of the URL fragment (they don't hit the server),
 * stash them in localStorage, and proceed to /devices.
 *
 * URL fragment is used (not query string) so the tokens aren't logged
 * server-side by Plesk/nginx access logs.
 */
export default function VorksReturnPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash.startsWith("#")
      ? window.location.hash.slice(1)
      : window.location.hash;
    const p = new URLSearchParams(hash);
    const access = p.get("access");
    const refresh = p.get("refresh");

    if (!access) {
      navigate("/login?vorks_error=no_access_token", { replace: true });
      return;
    }

    setToken(access);
    if (refresh) setRefreshToken(refresh);

    // Clear the fragment so a refresh doesn't leak tokens
    window.history.replaceState({}, "", "/vorks-return");

    // Fetch the user record so the AuthProvider has it on next navigate.
    // We force a hard reload to /devices so AuthProvider re-initializes
    // from localStorage instead of trying to merge state.
    api("/auth/me").finally(() => {
      window.location.href = "/devices";
    });
  }, [navigate]);

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "var(--bg)", color: "var(--text-dim)",
      fontFamily: "var(--mono)", fontSize: 12,
    }}>
      Signing you in via Vorks ID…
    </div>
  );
}
